import * as React from "react";
import {cx} from "emotion";

import "./delivery-options.scss";

import {CheckShowPricing}   from "@Common/logic/check-show-pricing";
import {cs}                 from "@Common/react/chain-services";
import {NumberInputBinding} from "@Common/react/number-input-binding";
import {InformationBadge}   from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import {Select}             from "@Common/ui-components/heavy/common/design2/select/select";
import {sort}               from "@Common/utils/collections";
import {chain}              from "@Common/utils/fs";
import {values}             from "@Common/utils/objects";

import {MoneySpanOld} from "@Xpresso/routes/common/form/money-span/money-span";

import {getQuantityErrorMessage} from "../../../../common/get-quantity-error-message";

export const DeliveryOptions = ({
    state,
    paperPrices,
    paperPrice,
    className,
    eh,
    domRef,
}) => cs(
    () => (
        <div className={cx("delivery-options-49d", className, eh.css)} ref={domRef.set}>
            <div className="left">
                <div className="label">
                    Quantity:
                </div>

                {isAllFixedQuantity(paperPrices) && paperPrices.length > 0 ? cs(
                    ({}) => chain(
                        Object.keys(paperPrices).map((p) => paperPrices[p].min),
                        sort,
                        (_) => Select({
                            list: _,
                            onChange: (q) => state.onChange(q),
                            isSelected: (q) => state.value === q,
                            forcedExpandLeft: true,
                            xdQaName: "Quantity",
                        })
                    )
                ) : cs(
                    ["binding", (_, next) => NumberInputBinding({
                        state,
                        next,
                    })],
                    ({binding}) => (
                        <input {...{
                            className: cx({
                                invalid: (
                                    !state.value ||
                                    state.value > paperPrices[paperPrices?.length - 1]?.max ||
                                    state.value < paperPrices[0]?.min
                                ),
                            }),
                            "xd-qa-type": "text_field",
                            "xd-qa-name": "Quantity",
                            ...binding,
                        }}/>
                    ),
                )}
            </div>

            {cs(
                ({}, next) => (
                    <div className="right">
                        {next()}
                    </div>
                ),
                ({}, next) => !paperPrice ? (
                    <div className="error" xd-qa-type="text" xd-qa-name="Error Message">
                        {getQuantityErrorMessage(state.value, {paperPrices})}
                    </div>
                ) : (
                    next()
                ),
                ({}, next) => CheckShowPricing({next}),
                ({}) => <>
                    <div className="label">
                        Subtotal:
                    </div>
                    {!paperPrice ? (
                        "--"
                    ) : paperPrice.priceMin !== paperPrice.priceMax ? (<>
                        {MoneySpanOld({
                            value: paperPrice.priceMin * (paperPrice.isFlatRate ? 1 : state.value),
                            alwaysShowDollarSymbol: true,
                            useFreeLabel: false,
                        })} - {MoneySpanOld({
                            value: paperPrice.priceMax * (paperPrice.isFlatRate ? 1 : state.value),
                            alwaysShowDollarSymbol: true,
                            useFreeLabel: false,
                        })}
                    </>) : (
                        MoneySpanOld({
                            value: (paperPrice.price ?? paperPrice.priceMin) * (paperPrice.isFlatRate ? 1 : state.value),
                            alwaysShowDollarSymbol: true,
                            useFreeLabel: false,
                        })
                    )}
                    <div className="money-span">
                        USD
                    </div>
                    {InformationBadge({
                        getTooltip: () => "The final amount may change if changes are made or if mailing list is selected on later step",
                        direction: "south-west",
                    })}
                </>,
            )}
        </div>
    ),
);

const isAllFixedQuantity = (prices) => !values(prices).find((p) => p["min"] !== p["max"]);

